import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateModellGelaender,
        updateStepsGelaender,
        updateWrapperIndexGelaender,
        updateMusterGelaender
      } from '../../../../store/actions/gelaender';
import {stahlgelaender} from '../../../../../assets/images/gelaender/stahlgelaender/muster/muster';
import {edelstahlgelaender} from '../../../../../assets/images/gelaender/edelstahlgelaender/muster/muster';
import {edelstahlgelaender_glas} from '../../../../../assets/images/gelaender/edelstahlgelaender_glas/muster/muster';
import {InputRadio} from '../../../../module/inputRadio';
import scrollToElement from '../../../../module/scrollToElement';


const Step_1 = (props) => {

   let gelaender = [stahlgelaender, edelstahlgelaender, edelstahlgelaender_glas];
   const [muster, updateMuster] = useState('');

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
       let modell_type = props.modell_type;
       let {index, kind, titel, muster} = props.data[modell_type].modell[0];
       let gelaender = document.querySelectorAll('.gelaender');
       let modal_box_header = document.querySelector('#modal_box_header');

        //update muster description
        updateMuster(muster);

        //scroll to Next Button Container
        scrollToElement();

       //update titel
       if (!muster) modal_box_header.innerHTML = kind;
       if (titel&&muster==='Sortiment') modal_box_header.innerHTML = kind+': '+titel;
       if (muster==='Eigenes Muster')  modal_box_header.innerHTML = kind+': Eigenes Muster';

       //update wrapper
       if (modell_type >= 0) index = props.data[props.modell_type].wrapper[0].wrapper1;

       //check of product box
       for (let i=0; i<gelaender.length; i++) {
           gelaender[i].classList.remove('check');
       }
       if (gelaender[index]&&index) gelaender[index].classList.add('check');


       //update steps
       props.updateSteps(0);

       //Weiter-Button aktivieren
       if (index || muster==='Eigenes Muster' || props.data[modell_type].allVisitedSteps) {
          props.updateSteps(1);
          props.setUpdateButtonActiveStepToFalse();
       } else {
          props.setUpdateButtonActiveStepToTrue();
       }

   }

    const selectModell = ev => {
        let index = ev.currentTarget.getAttribute('index');
        let titel = ev.currentTarget.getAttribute('titel');
        let image = ev.target.currentSrc;

        let wrapperObject = {
            index: index,
            ident: 1
        }
        let modellObject = {
            index: index,
            titel: titel,
            image: image
        }
        props.updateModell(modellObject);
        props.updateWrapperIndex(wrapperObject);
        updateItems();
   }

    const selectMuster = ev => {
        let muster = ev.target.value;
        updateMuster(muster);
        props.updateMuster(muster);
    }

   const arrayRadioItems = [
        {labalValue: 'Sortiment', labelTitel: 'Muster aus unserem Sortiment'},
        {labalValue: 'Eigenes Muster', labelTitel: 'Eigenes Muster hochladen'}
    ]


   return (
           <div className="step_wrapper">
             <h2 className="step_header">Wählen Sie ein passendes Muster für Ihr Geländers aus</h2>
               <div className="step_icon_wrapper">
                <div className="inner_masseMenge_wrapper">
                    <div className="textfield-wrapper">
                        <InputRadio
                           arial_label='Muster'
                           name='Muster'
                           value={muster}
                           onChange={selectMuster}
                           arrayRadioItems={arrayRadioItems}
                        />
                    </div>
                </div>
                {muster === 'Sortiment'?
                    <div className="inner_form_wrapper gelaender_wrapper">
                        {gelaender[props.modell_type].map((elem, index) => (
                            <div key={index} onClick={selectModell} className="formWrapper gelaender" titel={elem.titel} index={index}>
                                <img className="imgform imgStahltreppenGelaender" src={elem.product_img} alt={elem.product_img} />
                                <p>{elem.titel}</p>
                            </div>
                        ))}
                    </div>
                :''
                }
                {muster === 'Eigenes Muster'?<p>Im lezten Schritt haben Sie die Möglichkeit ein eigenes Muster hochzuladen.</p>:''}
              </div>
          </div>
       )
}

const mapStateToProps = state => {
    return {
      data: state.gelaenderReducer.data,
      modell_type: state.gelaenderReducer.modell_type
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateModell: ev => dispatch(updateModellGelaender(ev)),
      updateWrapperIndex: ev => dispatch(updateWrapperIndexGelaender(ev)),
      updateSteps: ev => dispatch(updateStepsGelaender(ev)),
      updateMuster: ev => dispatch(updateMusterGelaender(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_1);
